// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=js"
// @generated from file vitesse/ai/v1/tools.proto (package vitesse.ai.v1, syntax proto3)
/* eslint-disable */
import { enumDesc, extDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
/**
 * Describes the file vitesse/ai/v1/tools.proto.
 */
export const file_vitesse_ai_v1_tools = /*@__PURE__*/ fileDesc("Chl2aXRlc3NlL2FpL3YxL3Rvb2xzLnByb3RvEg12aXRlc3NlLmFpLnYxIrUBCgZBaVRvb2wSEwoLZGVzY3JpcHRpb24YASABKAkSDwoHbXV0YXRlcxgCIAEoCBIPCgdjb25maXJtGAMgASgIEhcKD3NlcnZlcl9zdXBwbGllZBgEIAMoCRIQCghyZXF1aXJlZBgGIAMoCRIyCg1yZXNwb25zZV9zaXplGAUgASgOMhsudml0ZXNzZS5haS52MS5SZXNwb25zZVNpemUSFQoNc3RhbmRzX2luX2ZvchgHIAEoCSp3CgxSZXNwb25zZVNpemUSHQoZUkVTUE9OU0VfU0laRV9VTlNQRUNJRklFRBAAEhcKE1JFU1BPTlNFX1NJWkVfU01BTEwQARIWChJSRVNQT05TRV9TSVpFX1BBR0UQAhIXChNSRVNQT05TRV9TSVpFX0xBUkdFEAM6UwoHYWlfdG9vbBIeLmdvb2dsZS5wcm90b2J1Zi5NZXRob2RPcHRpb25zGMuHAyABKAsyFS52aXRlc3NlLmFpLnYxLkFpVG9vbFIGYWlUb29siAEBQr0BChFjb20udml0ZXNzZS5haS52MUIKVG9vbHNQcm90b1ABWkZnaXRodWIuY29tL01vdmVuZGktYWkvdml0ZXNzZS1wbGF0Zm9ybS9wcm90by9nZW4vZ28vdml0ZXNzZS9haS92MTthaXYxogIDVkFYqgINVml0ZXNzZS5BaS5WMcoCDVZpdGVzc2VcQWlcVjHiAhlWaXRlc3NlXEFpXFYxXEdQQk1ldGFkYXRh6gIPVml0ZXNzZTo6QWk6OlYxYgZwcm90bzM", [file_google_protobuf_descriptor]);
/**
 * Describes the message vitesse.ai.v1.AiTool.
 * Use `create(AiToolSchema)` to create a new message.
 */
export const AiToolSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_tools, 0);
/**
 * @generated from enum vitesse.ai.v1.ResponseSize
 */
export var ResponseSize;
(function (ResponseSize) {
    /**
     * @generated from enum value: RESPONSE_SIZE_UNSPECIFIED = 0;
     */
    ResponseSize[ResponseSize["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * a scalar, a status, a handful of fields
     *
     * @generated from enum value: RESPONSE_SIZE_SMALL = 1;
     */
    ResponseSize[ResponseSize["SMALL"] = 1] = "SMALL";
    /**
     * a bounded page — safe to read whole
     *
     * @generated from enum value: RESPONSE_SIZE_PAGE = 2;
     */
    ResponseSize[ResponseSize["PAGE"] = 2] = "PAGE";
    /**
     * must be filtered/aggregated server-side before it reaches a prompt
     *
     * @generated from enum value: RESPONSE_SIZE_LARGE = 3;
     */
    ResponseSize[ResponseSize["LARGE"] = 3] = "LARGE";
})(ResponseSize || (ResponseSize = {}));
/**
 * Describes the enum vitesse.ai.v1.ResponseSize.
 */
export const ResponseSizeSchema = /*@__PURE__*/ enumDesc(file_vitesse_ai_v1_tools, 0);
/**
 * 50000-99999 is the range reserved for internal, non-published extensions.
 *
 * @generated from extension: optional vitesse.ai.v1.AiTool ai_tool = 50123;
 */
export const ai_tool = /*@__PURE__*/ extDesc(file_vitesse_ai_v1_tools, 0);
//# sourceMappingURL=tools_pb.js.map